(function () {
    'use strict';
    /* directive with list of appointment-items of one agenda */
    var module = angular.module('uwAgenda.agenda');
    module.directive('agendaAppointmentList', ['$rootScope', '$translate', 'AgendaItemResizeObserverService', 'DateService', 'DownloadService', 'HelperService', 'AppointmentService', 'Alert', 'ExportFormat', 'AgendaBroadcast', 'AgendaFilterBroadcast', AgendaAppointmentListDirectiveFn]);

    function AgendaAppointmentListDirectiveFn($rootScope, $translate, AgendaItemResizeObserverService, DateService, DownloadService, HelperService, AppointmentService, Alert, ExportFormat, AgendaBroadcast, AgendaFilterBroadcast) {
        var directive = {
            restrict: 'E',
            link: link,
            templateUrl: '/app/agenda/templates/agenda-appointment-list.template.html',
            scope: {
                agenda: '=',
                confirmAllPossible: '@?', // possible to confirm all ?
                deleted: '@?', // only deleted appointments 
                urgent: '@?', // only urgent appointments
                unconfirmed: '@?', // only unconfirmed appointments
                states: '=?', // list of appointment-states filtering,
                isPaid: '=',
                isVideoconsult: '=',
                filterDates: '=?'
            }
        };

        function link(scope, element) {

            // counter
            scope.counter = 0;
            // list
            scope.appointments = [];
            // collapse
            scope.collapsed = false;

            // start and end-date
            if (!scope.filterDates){
                scope.filterDates = {
                    startDate: null,
                    endDate: null
                };
            }

            // number of appointments to load
            var number = 50;            
            // show date filter
            scope.showDate = false;
            scope.infoMessage = '';


            activate();

            // activate
            function activate() {
                /// urgent in the future -> other in the past
                if (scope.urgent && scope.urgent === "true") {
                    if (!scope.filterDates || !scope.filterDates.startDate) {
                        scope.filterDates.startDate = DateService.data.date;
                    }
                    // 6 months in the future
                    if (!scope.filterDates || !scope.filterDates.endDate) {
                        scope.filterDates.endDate = addSixMonth(scope.filterDates.startDate);
                    }
                } // if
                else {
                    // end-date is selected date
                    if (!scope.filterDates || !scope.filterDates.endDate){
                        scope.filterDates.endDate = DateService.data.date;
                    }
                    // one week in the past if not set
                    if (!scope.filterDates || !scope.filterDates.startDate){
                        scope.filterDates.startDate = pastWeek(scope.filterDates.endDate);
                    }
                } // else
                
                // possible to confirm-all ?
                scope.confirmAllPossible = scope.confirmAllPossible ? scope.confirmAllPossible : true; // default yes

                // load appointments by agenda
                load();

                // listen
                listen();
                
            } // activate

            // collapse
            scope.collapse = function () {
                scope.collapsed = !scope.collapsed;
            };

            // print
            scope.print = function (documentType) {
                let exportFormat = ExportFormat.PDF.value;
                if (documentType === 'word')
                {
                    exportFormat = ExportFormat.WORD.value
                }
                DownloadService.exportAppointmentList(exportFormat, scope.agenda.owner.id, scope.filterDates.startDate, scope.filterDates.endDate, scope.states, scope.deleted, scope.unconfirmed, scope.urgent, scope.counter).then(function (result) {
                    DownloadService.openReport(exportFormat, result, "appointments");
                });
            };


            // confirm appointments for selected agenda 
            scope.confirmAll = function () {
                HelperService.block(element);                

                var confirmAllDeletedAppointments = scope.deleted === "true";
                AppointmentService.confirmAll(confirmAllDeletedAppointments)
                                  .then(function (numberOfConfirmedAppointments) {
                     
                    HelperService.unblock(element);

                    var successMessage = $translate.instant('marked_all_appointments_as_seen', {count: numberOfConfirmedAppointments});
                    Alert.success(successMessage);

                    load();
                });
            };

            // load more
            scope.more = function () {
                if (scope.urgent && scope.urgent === "true") {
                    scope.filterDates.endDate = addSixMonth(scope.filterDates.endDate);
                }
                else if ((scope.deleted && scope.deleted === "true") || (scope.unconfirmed && scope.unconfirmed === "true")) {
                    number += 10;
                } // else if
                else {
                    scope.filterDates.startDate = pastWeek(scope.filterDates.startDate);
                }

                // fetch
                fetch();
            };

            // fetch appointments
            function fetch() {
                scope.showDate = false;
                if (scope.deleted && scope.deleted === "true") {
                    AppointmentService.listDeletedByAgenda(scope.agenda.id, number).then(function (result) {
                        HelperService.unblock(element);
                        scope.appointments = result;
                        scope.counter = scope.appointments.length;
                        scope.infoMessage = $translate.instant('removed_appointments_info_message');
                        setTimeout(() => AgendaItemResizeObserverService.observe());
                    });
                } // if
                else if (scope.unconfirmed && scope.unconfirmed === "true") {
                    AppointmentService.listUnconfirmedByAgenda(scope.agenda.id, number).then(function (result) {
                        HelperService.unblock(element);
                        scope.appointments = result;
                        scope.counter = scope.appointments.length;                        
                        scope.infoMessage = $translate.instant('new_appointments_info_message');
                        setTimeout(() => AgendaItemResizeObserverService.observe());
                    });
                } // else if
                else {
                    scope.showDate = true;
                    AppointmentService.listByAgenda(scope.agenda.id, scope.filterDates.startDate, scope.filterDates.endDate, scope.states, scope.urgent, scope.isPaid, scope.isVideoconsult).then(function (result) {
                        HelperService.unblock(element);
                        scope.appointments = result;
                        scope.counter = scope.appointments.length;
                        setTimeout(() => AgendaItemResizeObserverService.observe());
                    });
                } // else 
                
                // set an extra scope so they are not immediately bind on screen while changing in filter
                scope.startDate = scope.filterDates.startDate;
                scope.endDate = scope.filterDates.endDate
            } // fetch


            // past week
            function pastWeek(date) {
                return moment(date).subtract(7, 'day').toDate();
            }


            // add three month
            function addThreeMonth(date) {
                return moment(date).add(3, 'month').toDate();
            }
            // add six month
            function addSixMonth(date) {
                return moment(date).add(6, 'month').toDate();
            }

            // load the appointments
            function load() {
                HelperService.block(element);
                // clear data to force view-update
                scope.appointments = [];

                // call api to get appointments
                fetch();
            }


            // listen on events
            function listen() {
                // listen on confirmed-appointments
                var confirmListener = scope.$on(AgendaBroadcast.AppointmentConfirmed, function (event, agendaId) {
                    // current agenda ?
                    if (agendaId !== null && agendaId === scope.agenda.id) {
                        scope.counter--;
                    } // if
                });

                var refreshListener = scope.$on(AgendaFilterBroadcast.ListRefresh, function (event, agendaId) {
                    // current agenda ?
                    if (agendaId !== null && agendaId === scope.agenda.id) {
                        load();
                    } // if
                });


                // on destroy
                scope.$on("$destroy", function () {
                    confirmListener();
                    confirmListener = null;
                    refreshListener();
                    refreshListener = null;
                    scope.appointments = null;
                    scope.counter = null;
                    scope.filterDates = null;
                });
            }

        } // link

        return directive;
    }
})();